angular.module('app.factories').factory('groupsListFilterFactory', ($translate, $state, $log, listFilter) => {
    const groupsListFilter = listFilter;

    groupsListFilter
        .setAttributes({
            extendByDates: false,
            name: 'groupsListFilter',
            providers: [],
        })
        .setFields({
            filter: {
                type: 'text',
                class: 'uk-width-medium-3-4',
                label: $translate.instant('search'),
                default: '',
            },
            reset: {
                type: 'reset',
                class: 'uk-width-medium-1-4',
            },
        }).listFilter = (group) => {
        if (!group || !groupsListFilter.fields.filter.value) {
            return true;
        }

        const parts = groupsListFilter.fields.filter.value.split('+');
        const regExp = new RegExp(parts.join('|'), 'i');
        const subject = [group.name, group.description, group.owner.fullname].join(' ');

        return regExp.test(subject);
    };

    return groupsListFilter;
});
